module.exports = __webpack_public_path__ + "videos/video-lp-2023-mobile.df8fa83.mp4";